import { render } from "./NostoProductRecommendationsGrid.vue?vue&type=template&id=911a7ad4&scoped=true"
import script from "./NostoProductRecommendationsGrid.vue?vue&type=script&lang=js"
export * from "./NostoProductRecommendationsGrid.vue?vue&type=script&lang=js"

import "./NostoProductRecommendationsGrid.vue?vue&type=style&index=0&id=911a7ad4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911a7ad4"]])

export default __exports__